import React, { SyntheticEvent, useEffect, useRef } from 'react';

import { Stack, Button } from 'src/viewLayer/components/DesignSystem';
import { RUNTIME_ENVIRONMENT } from 'src/dataLayer/env';
import { Input } from 'src/viewLayer/components/nodes/InputNode/input';
import { t } from 'src/viewLayer/helpers/translations';
import { EmailSignupProps } from './types';
import { Captcha } from 'src/viewLayer/components/nodes/InputNode/Captcha';
import { handleSubmitWithCaptcha, getCaptchaConfig } from 'src/viewLayer/components/nodes/InputNode/Captcha/helpers';
import { CaptchaConfig } from './Captcha/types';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

export const EmailSignup = ({ nodeInputs,
  submitParams,
  nodeConfig,
  inProgress
}: EmailSignupProps): JSX.Element => {
  const [captchaConfig, setCaptchaConfig] = React.useState<CaptchaConfig>();
  const captchaRef = useRef(null);
  // we need to check the runtime env so that we don't show the captcha in the UATs
  const showCaptcha = nodeConfig?.options?.showCaptcha && RUNTIME_ENVIRONMENT !== 'development';

  // Check if captcha should be used on this node and if a captcha config was already set.
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    if (showCaptcha && !captchaConfig) getCaptchaConfig(setCaptchaConfig);
  }, [showCaptcha, captchaConfig]);

  return (
    <form
      onSubmit={ (event): void | Promise<void> =>
        handleSubmitWithCaptcha({ event, showCaptcha, captchaRef, submitParams }) }
    >
      <Stack gap={{ xxxsmall: tokens.size.space.large, medium: tokens.size.space.xlarge }}>
        {
          nodeInputs.map((inputName) => (
            <Input
              key={ inputName }
              inputName={ inputName }
              currentInput={ submitParams.currentInput[inputName] }
              onEnterKeyDown={ (event: React.ChangeEvent<HTMLInputElement>): void | Promise<void> =>
                handleSubmitWithCaptcha({ event, showCaptcha, captchaRef, submitParams })
              }
            />
          )
          )
        }
        {
          showCaptcha && captchaConfig &&
          <Captcha
            captchaRef={ captchaRef }
            submitParams={ submitParams }
            captchaConfig={ captchaConfig }
          />
        }
        <Button
          id="continue"
          className="continue-button"
          data-testid="continue"
          fullWidth
          disabled={ inProgress }
          onClick={ (event: SyntheticEvent): void | Promise<void> =>
            handleSubmitWithCaptcha({ event, showCaptcha, captchaRef, submitParams })
          }
        >
          { t(nodeConfig.nextButtonLabel) }
        </Button>
      </Stack>
    </form>
  );
};
